export default {
  funds: {
    is: 'Sjóðir',
    en: 'Mutual funds',
  },
  fundPrice: {
    is: 'Gengi sjóða',
    en: 'Fund price',
  },
  dataDisclaimer: {
    is: 'Gengi sjóða og ávöxtunartölur uppfærast á hverjum viðskiptadegi.',
    en: 'Fund price and figures on returns are updated daily',
  },
  currency: {
    is: 'Mynt',
    en: 'Currency',
  },
  price: {
    is: 'Gengi',
    en: 'Price',
  },
  oneMonth: {
    is: '1 mán.',
    en: '1M',
  },
  threeMonths: {
    is: '3 mán.',
    en: '3M',
  },
  sixMonths: {
    is: '6 mán.',
    en: '6M',
  },
  yearToDate: {
    is: 'Á árinu',
    en: 'YTD',
  },
  oneYear: {
    is: '1 ár',
    en: '1 year',
  },
  twoYears: {
    is: '2 ár',
    en: '2 years',
  },
  threeYears: {
    is: '3 ár',
    en: '3 years',
  },
  fourYears: {
    is: '4 ár',
    en: '4 years',
  },
  fiveYears: {
    is: '5 ár',
    en: '5 years',
  },
  volatility: {
    is: 'Sveiflur',
    en: 'Volatility',
  },
  buy: {
    is: 'Kaupa',
    en: 'Buy',
  },
  bidRate: {
    is: 'Kaupgengi',
    en: 'Buy',
  },
  askRate: {
    is: 'Sölugengi',
    en: 'Sell',
  },
  nominalReturn: {
    is: 'Nafnávöxtun',
    en: 'Nominal return',
  },
  nominalReturnAnnualized: {
    is: 'Nafnávöxtun á ársgrundvelli',
    en: 'Annualized nominal return',
  },
  rate: {
    is: 'Gengi',
    en: 'Rate',
  },
  date: {
    is: 'Dagsetning',
    en: 'Date',
  },
  foreignCurrencyDisclaimer: {
    landsbref: {
      is: 'Hægt er að eiga viðskipti með hlutdeildarskírteini í sjóði sem gerður er upp í erlendri mynt í gegnum Verðbréfa- og lífeyrisþjónustu Landsbankans í síma 410 4040.',
      en: 'To trade in unit shares in funds that are settled in a foreign currency, please contact Investment Services at +354 410 4040.',
    },
    landsbankinn: {
      is: 'Hægt er að eiga viðskipti með hlutdeildarskírteini í sjóði sem gerður er upp í erlendri mynt í gegnum Verðbréfa- og lífeyrisþjónustu bankans í síma 410 4040.',
      en: 'To trade in unit shares in funds that are settled in a foreign currency, please contact Investment Services at +354 410 4040.',
    },
  },
  einkabrefDisclaimer: {
    landsbref: {
      is: 'Einkabréf eru einungis ætluð viðskiptavinum Einkabankaþjónustu Landsbankans.',
      en: 'Einkabréf is reserved for customers of Landsbankinn Private Banking.',
    },
    landsbankinn: {
      is: 'Einkabréf eru einungis ætluð viðskiptavinum Einkabankaþjónustu bankans.',
      en: 'Einkabréf is reserved for customers of Landsbankinn Private Banking.',
    },
  },
  nonUcitsDisclaimer: {
    is: '*Sérhæfður sjóður fyrir almenna fjárfesta, veita þarf upplýsingar um þekkingu og reynslu áður en fjárfest er í sjóði.',
    en: '*Alternative investment fund for retail investors, requiring customers to provide information about their knowledge and experience prior to investment.',
  },
  fundsDisclaimer: {
    is: 'Ávöxtun sem birt er í töflunni hér fyrir ofan er nafnávöxtun í uppgjörsmynt hvers sjóðs að frádregnum kostnaði sem fallið hefur á sjóðinn á hverjum tíma, svo sem umsýsluþóknun, viðskiptakostnaður og annar kostnaður. Gjald við kaup og afgreiðslugjald sem er innheimt fyrir fjárfestingu er ekki innifalið í útreikningi á ávöxtun sjóðanna.',
    en: 'Return on UCITS and investment funds is presented as nominal return in ISK net of ongoing costs incurred by the fund.',
  },
  fundsDisclaimer2: {
    is: 'Áhætta fylgir ávallt fjárfestingu í sjóðum þar sem gengi þeirra getur bæði hækkað og lækkað vegna verðbreytinga á eignum sjóðanna og vegna gengisflökts gjaldmiðla þegar eignir sjóða eru í erlendum gjaldmiðlum. Ávöxtun í fortíð gefur ekki áreiðanlega vísbendingu um framtíðarárangur og fjárfestar kunna að fá minna til baka en upphaflega var fjárfest fyrir.',
    en: 'Investment in funds always involves risk as the price of units can both increase and decrease, due amongst other things to changes in the value of underlying assets and exchange rate fluctuations where fund assets are in foreign currencies.',
  },
  fundsDisclaimer3: {
    landsbref: {
      is: 'Sjóðirnir eru reknir af Landsbréfum hf., rekstrarfélagi verðbréfasjóða og rekstraraðila sérhæfðra sjóða með starfsleyfi á Íslandi og heyrir undir eftirlit Fjármálaeftirlits Seðlabanka Íslands.',
      en: 'The funds are managed by Landsbréf hf., a management company licensed to operate in Iceland and supervised by the Financial Supervisory Authority of the Central Bank of Iceland. We encourage you to familiarise yourself with the prospectus, key investor information and fact sheet available for each fund. Other information includes terms and conditions, a summary of conflict of interest and risk description for trading in financial instruments.',
    },
    landsbankinn: {
      is: 'Sjóðirnir eru reknir af Landsbréfum hf., rekstrarfélagi með starfsleyfi á Íslandi og heyrir undir eftirlit Fjármálaeftirlits Seðlabanka Íslands. Við bendum þér á að kynna þér útboðslýsingu, lykilupplýsingar og upplýsingablöð sjóðanna sem finna má undir hverjum sjóði. Einnig getur þú kynnt þér skilmála, útdrátt um hagsmunaárekstra og áhættulýsingu vegna viðskipta með fjármálagerninga.',
      en: 'The funds are managed by Landsbréf hf., a management company licensed to operate in Iceland and supervised by the Financial Supervisory Authority of the Central Bank of Iceland. We encourage you to familiarise yourself with the prospectus, key investor information and fact sheet available for each fund. Other information includes terms and conditions, a summary of conflict of interest and risk description for trading in financial instruments.',
    },
  },
  selectInformation: {
    is: 'Veldu upplýsingar',
    en: 'Select information',
  },
};
